import React, {useState, useEffect} from 'react';
import clsx from 'clsx';
import {useCartConfig} from "../../../../contexts/CartConfigContext";

export default function ToolPriceDisplay({product}) {
  const cartConfig = useCartConfig();

  if (cartConfig.hidePricing) {
    return <div />
  }

  if (!product)
    return null;

  const {regularPriceCents} = product;
  if (!regularPriceCents)
    return null;

  let price = new Money(regularPriceCents);

  return <div className="text-right text-2xl">
    {price.toString()}
  </div>
}
